const EnumLanguage = Object.freeze({
  ENGLISH: "ENGLISH",
});

export default EnumLanguage;
